import { Outlet, createFileRoute } from "@tanstack/react-router";

import { ProductLogoMediumPeople as LogoPeople } from "@/components/Logo";
import type { TabWithIndicatorProps } from "@/components/Navigation/HeaderTabs";
import { ProductHeader } from "@/components/ProductHeader";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { defaultNS, useTranslation } from "@/lib/i18n";

export const Route = createFileRoute("/_staff/people/_list")({
  component: PeopleLayout,
});

// FIXME: アイコンは仮のもの。要変更。

function PeopleLayout() {
  const { t } = useTranslation(defaultNS);
  useDocumentTitle(t("pages.people.title"));

  const tabs = [
    {
      to: "/people",
      children: t("common.list.overview"),
      activeOptions: { exact: true },
    },
    { to: "/people/workforce", children: t("common.list.workforce") },
    {
      to: "/people/alumni",
      children: t("common.list.alumni"),
    },
    // {
    //   to: "/people/people-graph",
    //   children: t("common.list.peopleGraph"),
    // },
    { to: "/people/alerts", children: t("common.list.alerts") },
    {
      to: "/people/salary-and-payment",
      children: t("common.list.salaryPayment"),
    },
    {
      to: "/people/operation-activity",
      children: t("common.list.operationActivity"),
    },
    { to: "/people/community", children: t("common.list.community") },
    {
      to: "/people/rule-and-policy",
      children: t("common.list.ruleAndPolicy"),
    },
    { to: "/people/settings", children: t("common.list.settings") },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div className="flex flex-col">
      <ProductHeader
        Logo={LogoPeople}
        name={t("pages.people.title")}
        tabs={tabs}
        type="resource"
      />
      <Outlet />
    </div>
  );
}
